import { Pill, Tooltip } from '@sanlam-glacier/app-common/components';
import styles from './exposure-breaches.module.scss';
import { Reg28ExposureBreachModelMock } from '../../../types/regulation-28/regulation-28.interfaces';

type ExposureBreachesProps = {
  firstBreaches: Reg28ExposureBreachModelMock[];
  restOfBreaches: Reg28ExposureBreachModelMock[];
};

export const ExposureBreaches = ({ firstBreaches, restOfBreaches }: ExposureBreachesProps) => {
  const testComponentName = 'regulation28ExposureBreach';

  return (
    <div className={styles.exposureBreachesCell}>
      {firstBreaches.length > 0 &&
        firstBreaches.map((breach) => (
          <div
            key={`${breach.assetClassName}`}
            data-testid={`${testComponentName}${breach.assetClassName}`}
          >
            <Pill size={Pill.SIZE.SMALL} variant={Pill.VARIANT.TERTIARY} status={Pill.STATUS.ERROR}>
              {breach.assetClassName}
            </Pill>
          </div>
        ))}
      {restOfBreaches.length > 0 && (
        <Tooltip
          data-testid={`${testComponentName}ExtraBreachesTooltip`}
          position={Tooltip.POSITION.TOP_END}
          content={restOfBreaches.map((breach, index) => (
            <div key={breach.assetClassName}>
              {index > 0 && <br />}
              {breach.assetClassName}
            </div>
          ))}
        >
          <div>
            <Pill
              data-testid={`${testComponentName}ExtraBreachesPill`}
              key={`extra-breaches-pill`}
              size={Pill.SIZE.SMALL}
              variant={Pill.VARIANT.TERTIARY}
              status={Pill.STATUS.ERROR}
            >
              {`+${restOfBreaches.length}`}
            </Pill>
          </div>
        </Tooltip>
      )}
    </div>
  );
};
